import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import Clarity from '@microsoft/clarity';
import { MatIconModule } from '@angular/material/icon';
import { environment } from 'environments/environment';
import { clarityInitialized, setClarityInitialized } from '../../utils/clarity-state';
import { GA4Service } from '../../../core/services/ga4.service';

interface CookiePreferences {
  analytics: boolean;
  ads: boolean;
}

@Component({
  selector: 'app-cookie-consent',
  standalone: true,
  imports: [CommonModule, RouterLink, MatIconModule],
  templateUrl: './cookie-consent.html',
  styleUrl: './cookie-consent.scss'
})
export class CookieConsentComponent implements OnInit {
  showBanner = false;
  showDetails = false;
  showAnalyticsCookies = false;
  showAdsCookies = false;
  analyticsEnabled = true;
  adsEnabled = true;

  private readonly CONSENT_KEY = 'cookie_consent';
  private ga4Service = inject(GA4Service);

  ngOnInit(): void {
    const stored = localStorage.getItem(this.CONSENT_KEY);
    if (!stored) {
      this.showBanner = true;
    } else {
      const prefs: CookiePreferences = JSON.parse(stored);
      this.analyticsEnabled = prefs.analytics;
      this.adsEnabled = prefs.ads;
      this.applyConsent(prefs);
    }
  }

  acceptAll(): void {
    this.analyticsEnabled = true;
    this.adsEnabled = true;
    this.saveAndApply();
  }

  declineAll(): void {
    this.analyticsEnabled = false;
    this.adsEnabled = false;
    this.saveAndApply();
  }

  savePreferences(): void {
    this.saveAndApply();
  }

  openSettings(): void {
    this.showBanner = true;
    this.showDetails = true;
  }

  private saveAndApply(): void {
    const prefs: CookiePreferences = {
      analytics: this.analyticsEnabled,
      ads: this.adsEnabled
    };
    localStorage.setItem(this.CONSENT_KEY, JSON.stringify(prefs));
    this.showBanner = false;
    this.applyConsent(prefs);
  }

  private applyConsent(prefs: CookiePreferences): void {
    // Update GA4 consent
    this.ga4Service.updateConsent(prefs.analytics, prefs.ads);
    
    if (prefs.analytics && environment.clarityId && !clarityInitialized()) {
      // Initialize Clarity if not already initialized
      Clarity.init(environment.clarityId);
      setClarityInitialized(true);
    }
    
    try {
      Clarity.consentV2({
        analytics_Storage: prefs.analytics ? 'granted' : 'denied',
        ad_Storage: prefs.ads ? 'granted' : 'denied'
      });
    } catch {
      // Clarity not yet initialized — consent will apply on next page load
    }
  }
}
